import React from 'react';
import {Col, Container, Row, Accordion} from "react-bootstrap";

function Question(props) {
    return (
        <div className={props.color ? 'services_question bg_color p-100' : 'services_question p-100'}>
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="question_title">
                        <div className="example" data-text="FAQs">
                            <h2>Frequently Asked Questions</h2>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="services_faqs">
                        <Accordion defaultActiveKey="0">

                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    How can I tell if my business is ready for digital transformation?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>A few key indicators can help you determine if your business is ready for digital
                                        transformation. These include a willingness to embrace change and try new
                                        things, a continuous learning and improvement culture, and a commitment to
                                        customer satisfaction and service. Other factors to consider may include the
                                        availability of resources and budget, the level of competition in your industry,
                                        and the readiness of your employees and leadership team.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    What are some common challenges that businesses face during digital transformation?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Some common challenges businesses face during digital transformation include a
                                        lack of resources or budget, resistance to change from employees or leadership,
                                        and a lack of clear goals or vision. Other challenges may include a lack of
                                        understanding or expertise in new technologies, difficulty in integrating new
                                        systems and processes, and security and privacy concerns.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>
                                    How can TekRevol help me overcome the potential challenges and successfully navigate
                                    digital transformation?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>TekRevol has a team of experienced professionals who have expertise in digital
                                        transformation. We have a record of success in helping businesses to overcome
                                        common challenges and successfully navigate digital transformation. Our team has
                                        the skills and knowledge to help you create a custom solution that meets your
                                        specific needs and goals. We can work with you to identify and prioritize your
                                        digital initiatives, allocate resources effectively, and measure progress and
                                        success. Whether you're looking to improve your operations, increase sales, or
                                        better serve your customers, we can help you successfully navigate digital
                                        transformation.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Question;